import FiltersBar from 'components/FiltersBar';
import FormulaFiltersBar from 'pages/Supplies/components/FiltersBar';
import FormulaCard from 'pages/Supplies/components/Formula/components/FormulaForm/components/MaterialCard/MaterialsCard';
import FormulaFilters from 'pages/Supplies/components/Formula/components/FormulaFiltersPanel';
import ManufacturerCard from 'pages/Supplies/components/Manufacturers/ManufacturerCard';
import ManufacturersSorting from 'pages/Supplies/components/Manufacturers/SortingPanel';
import InventoryCard from 'pages/Supplies/components/Inventory/MaterialCard';
import InventoryFilters from 'pages/Supplies/components/Inventory/FiltersPanel';
import GlassBeadCard from 'pages/Supplies/components/GlassBeads/GlassBeadCard';
import GlassBeadsSorting from 'pages/Supplies/components/GlassBeads/SortingPanel';

const uniqueBy = (records, key) => [
  ...new Map(records.filter(Boolean).map((record) => [record[key], record])).values(),
];

export const TABS = [
  {
    index: 0,
    name: 'formula',
    label: 'Formula',
    href: '/supplies/archive/formula',
    entity: 'materials',
    drawer: 'formula',
    Card: FormulaCard,
    FiltersBar: FormulaFiltersBar,
    Panel: FormulaFilters,
    searchKeys: ['name'],
    defaultFilters: (settings) => ({
      unitType: 'All',
      markingType: 'All',
      sortBy: 'name',
      sortOrder: 'asc',
      measurement: settings?.measurement || 'All',
    }),
    panelProps: (filters) => ({ filter: filters }),
  },
  {
    index: 1,
    name: 'manufacturers',
    label: 'Manufacturers',
    href: '/supplies/archive/manufacturers',
    entity: 'manufacturers',
    drawer: 'manufacturer',
    Card: ManufacturerCard,
    FiltersBar,
    Panel: ManufacturersSorting,
    searchKeys: ['publication408', 'designation', 'supplierCode', 'name'],
    defaultFilters: () => ({ sortBy: 'name', sortOrder: 'asc' }),
    cardProps: (settings) => ({ orgSettings: settings }),
    panelProps: (filters, rows, settings) => ({ sorting: filters, orgSettings: settings }),
  },
  {
    index: 2,
    name: 'materials',
    label: 'Materials',
    href: '/supplies/archive/inventory',
    entity: 'inventory',
    drawer: 'inventory',
    Card: InventoryCard,
    FiltersBar,
    Panel: InventoryFilters,
    searchKeys: ['material.name', 'colorOrNumber', 'lotNumber', 'manufacturer.name', 'symbolOrWidth'],
    infinite: true,
    defaultFilters: () => ({
      colorOrNumber: 'All',
      manufacturerId: 'All',
      sortBy: 'material',
      sortOrder: 'asc',
    }),
    isUnfiltered: ({ colorOrNumber, manufacturerId }) =>
      [colorOrNumber, manufacturerId].every((value) => !value || value === 'All'),
    // the archive has no active lists to offer, so the options come from the archived rows themselves
    panelProps: (filters, rows, settings) => ({
      filter: filters,
      manufacturers: uniqueBy(rows.map(({ manufacturer }) => manufacturer), '_id'),
      colors: [...new Set(rows.map(({ colorOrNumber }) => colorOrNumber).filter(Boolean))],
      orgSettings: settings,
    }),
  },
  {
    index: 3,
    name: 'glass-beads',
    label: 'Reflective Media',
    href: '/supplies/archive/reflective-media',
    entity: 'glassBeads',
    drawer: 'glassBead',
    Card: GlassBeadCard,
    FiltersBar,
    Panel: GlassBeadsSorting,
    searchKeys: ['name'],
    defaultFilters: () => ({ sortBy: 'name', sortOrder: 'asc' }),
    panelProps: (filters) => ({ sorting: filters }),
  },
];
